import type { WidgetTemplateDetailsEntity } from '../../widget-template-details/WidgetTemplateDetails.entity';
import type { TRenderScreen } from '../SettingsScreenRendererService';

import { WidgetTemplateDetails } from '../../widget-template-details/WidgetTemplateDetails';

export function renderWellLogsTemplateDetailsScreen(screen: WidgetTemplateDetailsEntity): TRenderScreen {
  return () => <WidgetTemplateDetails screen={screen} />;
}
